import THDStorageUtils, { SESSION_STORAGE } from '@thd-olt-global/thd-storage-utils';
import { GENERIC_ERROR, PRODUCT_LIMIT_ERROR } from '../components/shared/Constants';

export const getProductsByType = (products) => {
  if (!products?.length) {
    return {
      qcProducts: [],
      nonSharedQcProducts: [],
      majorAppliances: [],
      configurableBlinds: [],
      liveGoods: [],
      discontinuedOutOfStockUnavailable: []
    };
  }

  return {
    qcProducts: products.filter((product) => product.flag === 'QC_PRODUCT'),
    nonSharedQcProducts: products.filter((product) => product.flag === 'NON_SHARED_QC_PRODUCT'),
    majorAppliances: products.filter((product) => product.flag === 'MAJOR_APPLIANCE'),
    configurableBlinds: products.filter((product) => product.flag === 'CONFIGURABLE_BLINDS'),
    liveGoods: products.filter((product) => product.flag === 'LIVE_GOODS'),
    discontinuedOutOfStockUnavailable: products.filter((product) => product.flag === 'DISCONTINUED_OOS_UNAVAILABLE')
  };
};

export const formatProductsforCopy = (products) => {
  return products.map((product) => (
  `Product: ${product?.identifiers?.productLabel || product?.product?.description || 'N/A'}\n\
  SKU: ${product?.identifiers?.storeSkuNumber || product?.product?.sku || 'N/A'}\n\
  Brand: ${product?.identifiers?.brandName || 'N/A'}\n\
  Quantity: ${product?.quantity || product?.product?.quantity || 'N/A'}\n\
  itemId: ${product?.itemId || 'N/A'}\n\
  Type: ${product?.flag}`
  )).join('\n\n');
};

export const saveProjectIdOnSession = (projectId) => {
  if (!projectId) return;

  THDStorageUtils.set(SESSION_STORAGE, { key: 'quote-project-id', value: projectId });
};

export const triggerCloseQuoteAnalytics = (message) => {
  return window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.closeQuote',
    { settings: message }
  );
};

export const triggerErrorAnalytics = (error) => {
  const { graphQLErrors } = error;

  const errorMessage = graphQLErrors?.[0]?.message;
  const id = graphQLErrors?.[0]?.extensions?.Quote_Errors?.[0]?.errors?.[0]?.id;
  const httpStatus = graphQLErrors?.[0]?.extensions?.Quote_Errors?.[0]?.httpStatus;

  return window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.errorAnalytics', {
    error: [{
      type: httpStatus < 500 ? 'error' : 'system',
      displayType: 'inline',
      pageSection: 'add to quote',
      message: errorMessage,
      code: id
    }]
  });
};

export const triggerAdvisoryErrorAnalytics = (message) => {

  return window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.errorAnalytics', {
    error: [{
      type: 'advisory',
      displayType: 'inline',
      pageSection: 'add to quote',
      message,
      code: 'n/a'
    }]
  });
};

export const getErrorMessage = (error) => {
  if (!error) {
    return '';
  }
  const { message, graphQLErrors } = error;

  if (message && /CART_ERR_106_1/.test(message)) {
    return PRODUCT_LIMIT_ERROR;
  }
  if (message && /(50|51|40|41)/.test(message)) {
    return GENERIC_ERROR;
  }

  // check is API error message
  if (!message || message === 'null') {
    return graphQLErrors?.[0]?.extensions?.errorData?.[0]?.errors?.[0]?.description || '';
  }

  return message;
};